import { render, staticRenderFns } from "./FeedbackRecord.vue?vue&type=template&id=fc82b36c&scoped=true"
import script from "./FeedbackRecord.vue?vue&type=script&lang=js"
export * from "./FeedbackRecord.vue?vue&type=script&lang=js"
import style0 from "./FeedbackRecord.vue?vue&type=style&index=0&id=fc82b36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc82b36c",
  null
  
)

export default component.exports